import * as angular from "angular";

angular
  .module('triangular', [
    'ngMaterial',
    'triangular.components',
    'triangular.themes',
    'ui.router'
  ]);
